import { queryOptions } from "@tanstack/react-query";
import { getStoreByOwnerId, getStoreDetail, getStoreList, getStoreDateLog } from "../v1/store.service";
import type { getStoreByOwnerIdForm, getStoreDateLogForm, getStoreForm } from "../dtos/request/store.request";


/**
 * @description 매장 상세 정보 조회 API
 * @param id
 * @returns
 */
export const useStoreDetail = (id: string) =>
  queryOptions({
    queryKey: ["store-detail", id],
    queryFn: () => getStoreDetail(id),
    enabled: !!id,
  });

/**
 * @description 매장 리스트 조회 API
 * @param form
 * @returns
 */
export const useStoreList = (form: getStoreForm) =>
  queryOptions({
    queryKey: ["store-list", form.page, form.size, form.activeness],
    queryFn: () => getStoreList(form),
    retry: 1,
  });


export const useStoreByOwnerId = (form: getStoreByOwnerIdForm) => queryOptions({
  queryKey: ["store-list-byownerId", form.page, form.size],
  queryFn: () => getStoreByOwnerId(form),
  retry: 1
})

/** 매장 기간 변경 로그 (정지 이력 포함) */
export const useStoreDateLog = (id: string | number, form: getStoreDateLogForm) =>
  queryOptions({
    queryKey: ["store-date-log", String(id), form.page, form.size],
    queryFn: () => getStoreDateLog(id, form),
    enabled: !!id,
    retry: 1,
  });
